import { render, staticRenderFns } from "./LessonModel.vue?vue&type=template&id=6ac45ee6&"
import script from "./LessonModel.vue?vue&type=script&lang=js&"
export * from "./LessonModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports